import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function DeleteFoodStockFoodItemCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (foodStockItemId: string) {
    return await foodStockRepository.deleteFoodStockFoodItem(foodStockItemId)
  }
}
